export const validators = {
	email: /^[a-zA-Z0-9._%+-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/,
	phoneNumber: /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s./0-9]*$/,
	password: /^.{10,}$/,
	uuidV4:
		/^[0-9A-F]{8}-[0-9A-F]{4}-[4][0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}$/i,
	nonEmptyString: /^(?!\s+$).+/,
	time: /^\d+\.{0,1}([\d]{0,1})$/,
	number: /^\d+\.{0,1}\d{0,}$/,
	price: /^\d+$/,
	integer: /^\d+$/,
	domain: /:\/\/(.[^/]+)/,
	weight: /^\d+\.{0,1}\d{0,2}$/,
	url: /[(http(s)?)://(www.)?a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g,
	bold: /\*(\S.*?\S|\S)\*/g,
	italic: /_(\S.*?\S|\S)_/g,
	lineThrough: /~(\S.*?\S|\S)~/g,
	emailInString: /[a-zA-Z0-9s._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/g,
	phoneNumberInString:
		/(?:\+?\d{1,3}[.\s-]?)?(?:\(?\d{3}\)?[.\s-]?)?\d{3}[.\s-]?\d{4}/g,
};

export const rules = {
	firstName: {
		min: {
			value: 1,
			message: "First name has from 1 to 50 characters.",
		},
		max: {
			value: 50,
			message: "First name has from 1 to 50 characters.",
		},
	},
	lastName: {
		min: {
			value: 1,
			message: "Last name has from 1 to 50 characters.",
		},
		max: {
			value: 50,
			message: "Last name has from 1 to 50 characters.",
		},
	},
	middleName: {
		min: {
			value: 1,
			message: "Middle name has from 1 to 50 characters.",
		},
		max: {
			value: 50,
			message: "Middle name has from 1 to 50 characters.",
		},
	},
	nickname: {
		min: {
			value: 1,
			message: "Nickname has from 1 to 50 characters.",
		},
		max: {
			value: 50,
			message: "Nickname has from 1 to 50 characters.",
		},
	},
	email: {
		pattern: {
			value: validators.email,
			message: "Email is invalid.",
		},
	},
	phoneNumber: {
		pattern: {
			value: validators.phoneNumber,
			message: "Phone number is invalid.",
		},
	},
	password: {
		pattern: {
			value: validators.password,
			message: "Password must have at least 10 characters",
		},
	},
};
